import { IconProps } from '@models/icons';

function EventIcon({ size = 16, color }:IconProps) {
  return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
           className='icon' >
          <path d="M7.5769 7.47119V4.84619" stroke={color} strokeWidth="2" strokeLinecap="round"/>
          <path d="M7.5769 7.09619V4.09619" stroke={color} strokeWidth="2" strokeLinecap="round"/>
          <path d="M16.5769 7.09619V4.09619" stroke={color} strokeWidth="2" strokeLinecap="round"/>
          <path d="M18.5769 12.5962H5.28711" stroke={color} strokeWidth="2" strokeLinecap="round"/>
          <path d="M6.0769 19.9039H10.1538H13.8461H17.9231C18.4753 19.9039 18.9231 19.4561 18.9231 18.9039V8.59619C18.9231 8.04391 18.4753 7.59619 17.9231 7.59619H6.0769C5.52462 7.59619 5.0769 8.04391 5.0769 8.59619V18.9039C5.0769 19.4561 5.52462 19.9039 6.0769 19.9039Z" stroke={color} strokeWidth="2"/>
      </svg>
  );
}

export default EventIcon;
